var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-loader" }, [
      _c("div", { staticClass: "spin u-cover" }, [
        _c("span", { staticClass: "u-cover" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spin u-cover" }, [
        _c("span", { staticClass: "u-cover" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }